import React, { useState, useEffect } from "react";
import Select from "react-select"; // Cần cài đặt: npm install react-select
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";

const LeaveApprovalModal = ({ show, initialData, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    id: 0,
    stepOrder: 1,
    approverId: "",
    position: 0,
    note: "",
  });

  const [users, setUsers] = useState([]);

  // Lấy danh sách user
  useEffect(() => {
    if (show) {
      const fetchUsers = async () => {
        try {
          const res = await axiosClient.get(API_ENDPOINTS.users);
          setUsers(res.data || []);
        } catch (e) {
          console.error("❌ Failed to fetch users:", e);
        }
      };
      fetchUsers();
    }
  }, [show]);

  // Khởi tạo dữ liệu
  useEffect(() => {
    if (show) {
      if (initialData) {
        setFormData({
          id: initialData.id || 0,
          stepOrder: initialData.stepOrder || 1,
          approverId: initialData.approverId || "",
          position: initialData.position ?? 0,
          note: initialData.note || "",
        });
      } else {
        setFormData({
          id: 0,
          stepOrder: 1,
          approverId: "",
          position: 0,
          note: "",
        });
      }
    }
  }, [initialData, show]);

  // Chuẩn bị options cho react-select
  const userOptions = [
    { value: "", label: "-- No Specific User (Flexible) --" },
    ...users.map((u) => ({
      value: u.id,
      label: `${u.fullName || u.userName} (${u.email})`,
    })),
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      id: parseInt(formData.id) || 0,
      approverId: formData.approverId ? parseInt(formData.approverId) : null,
      stepOrder: parseInt(formData.stepOrder) || 1,
      position: parseInt(formData.position),
      note: formData.note,
    };
    onSave(payload);
  };

  if (!show) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <form onSubmit={handleSubmit}>
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                {formData.id ? "Edit Leave Approval Step" : "Add Leave Approval Step"}
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label small fw-bold">Step Sequence Order</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    min="1"
                    required
                    value={formData.stepOrder}
                    onChange={(e) => setFormData({ ...formData, stepOrder: e.target.value })}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Assign Specific Approver</label>
                  <Select
                    className="text-sm"
                    options={userOptions}
                    value={userOptions.find((opt) => opt.value === formData.approverId) || userOptions[0]}
                    onChange={(selected) => setFormData({ ...formData, approverId: selected.value })}
                    placeholder="Search and select user..."
                    isSearchable
                  />
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Required Authority Level</label>
                  <select
                    className="form-select form-select-sm"
                    value={formData.position}
                    onChange={(e) => setFormData({ ...formData, position: parseInt(e.target.value) })}
                  >
                    <option value={0}>General Staff</option>
                    <option value={1}>Department Manager</option>
                    <option value={2}>Division Manager</option>
                    <option value={3}>Board of Directors</option>
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold">Note / Instructions</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows="2"
                    value={formData.note}
                    onChange={(e) => setFormData({ ...formData, note: e.target.value })}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary btn-sm px-4">
                {formData.id ? "Update Step" : "Save Step"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LeaveApprovalModal;